import React from 'react';

import { Brand } from '../../../apis/enterprise/types';

export type BrandContextValue = {
  brand: Brand | undefined;
};

export const BrandContext = React.createContext<BrandContextValue>({
  brand: undefined,
});

export const useBrandContext = () => React.useContext(BrandContext);
export const BrandContextProvider = BrandContext.Provider;
